"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _colors = _interopRequireDefault(require("../colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var styles = {
  dotStyle: {
    border: 'none',
    background: _colors["default"].gray,
    width: '2px',
    bottom: '-1px',
    marginLeft: '-2px'
  },
  railStyle: {
    backgroundColor: _colors["default"].gray,
    height: '2px',
    zIndex: 1
  },
  trackStyle: {
    backgroundColor: _colors["default"].black,
    height: '2px',
    zIndex: 1
  }
};
var _default = styles;
exports["default"] = _default;